export default __webpack_public_path__ + "static/media/Machine, Grey.b212b7c7.png";